import { render, staticRenderFns } from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=template&id=17b1c4a5&"
import script from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports